import Vue from 'vue'
import material from "../request/material";
import api from '../request/api'  //  公用的接口
import community from '../request/community'  // 社区
import index from '../request/index' // 首页
import video from  '../request/video' // 视频
import message from '../request/message'// 消息
import job from '../request/job' // 职位
import task from '../request/task' // 任务大厅
import teacher from "../request/teacher"; // 讲师入驻
import expert from "../request/expert"; // 专家入驻
import active from '../request/active'
import vip from '../request/vip'
import station from "../request/transferStation";
import collection from "../request/collection";
const api_list = {
  material,
  api,
  community,
  index,
  video,
  message,
  job,
  task,
  vip,
  station,
  teacher,
  expert,
  active,
  collection
}
Vue.prototype.$requestApi = api_list



// WEBPACK FOOTER //
// ./src/utils/request.js